module.exports = __webpack_public_path__ + "img/15.ccf75ca5.jpg";